import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonVariant, ButtonSize, IconColor, IconName, IconSize, usePopoverHandlers, } from '@as/cotopaxi';
import { Breakpoint } from '@yonderland/andes-react';
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SecurityLevelsPopup } from '../../components/security-levels-popup/SecurityLevelsPopup';
import { AUTH_POPUP_BUTTON_WRAPPER_ID } from '../../constants/DOMElementsConstants';
import { DELAY } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import sessionActions from '../../redux/session/actions/SessionActions.creators';
import { AuthenticationContainer } from '../AuthenticationContainer';
import { AccountMenuContainer } from './AccountMenuContainer';
const AccountMenuItemContainer = ({ accountMenu, login, registration, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [didMount, setDidMount] = useState(false);
    const btnEl = useRef(null);
    const dispatch = useDispatch();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const { authUrl, isLoggedIn, postLogin } = useOAuth();
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const handleOpen = (e) => __awaiter(void 0, void 0, void 0, function* () {
        setTimeout(() => {
            handlePopoverOpen(e, btnEl.current);
        }, DELAY.DELAY_0);
    });
    useEffect(() => {
        if (!isNewAuth) {
            dispatch(sessionActions.createInitAction());
        }
        setDidMount(true);
    }, []);
    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        postLogin();
    }, [isLoggedIn]);
    return (_jsxs(_Fragment, { children: [_jsxs("span", { ref: btnEl, id: AUTH_POPUP_BUTTON_WRAPPER_ID, children: [_jsx(Breakpoint, { from: "lg", children: _jsx(Button, { variant: ButtonVariant.LINK_SUBTLE, size: ButtonSize.SMALL, onClick: !isNewAuth || isLoggedIn ? handleOpen : undefined, href: isNewAuth && !isLoggedIn ? authUrl : undefined, dataQA: "account", text: isLoggedIn ? t('account.account') : t('account.login.title.login'), iconRight: isNewAuth && !isLoggedIn
                                ? undefined
                                : {
                                    name: anchorEl ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN,
                                    color: IconColor.ACTION,
                                    size: IconSize.MINOR,
                                } }) }), _jsx(Breakpoint, { until: "lg", children: _jsx(Button, { onClick: !isNewAuth || isLoggedIn ? handleOpen : undefined, href: isNewAuth && !isLoggedIn ? authUrl : undefined, variant: ButtonVariant.NAVIGATION, dataQA: "account", icon: {
                                name: isLoggedIn ? IconName.USER_CHECK_SOLID : IconName.USER_SOLID,
                                size: IconSize.MAJOR,
                            } }) })] }), didMount &&
                (isLoggedIn === true ? (_jsxs(_Fragment, { children: [_jsx(AccountMenuContainer, { items: accountMenu.items, anchorEl: anchorEl, onClose: handlePopoverClose }), _jsx(SecurityLevelsPopup, {})] })) : (_jsx(AuthenticationContainer, { actionUri: (!!login && login.actionUri) || undefined, anchorEl: anchorEl, onClose: handlePopoverClose, registrationLink: (!!registration && registration.link) || undefined })))] }));
};
export default AccountMenuItemContainer;
